import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import SplitPane from "react-split-pane";
import Loader from "../../../../img/Document scan.gif"
import Swal from "sweetalert2";
import TableProperties from "./TableProperties";
import UseToggle from "../../../../Hooks/UseToggle";
import { Form, ListGroup, InputGroup } from "react-bootstrap";
import { saveAs } from 'file-saver';
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import DatasetViewer from "./DatasetViewerTool/DatasetViewer";
import ExportJSONData from "./ExportJSONData";
import ExportEXCELData from "./ExportEXCELData";
import ExportCSVData from "./ExportCSVData";

const DatasetListByColumn = ({ onMouseDown, tableRef }) => {
  const [formMetadataList, setFormMetadataList] = useState([]);
  const [formDataList, setFormDataList] = useState([]);
  const [formDataCount, setFormDataCount] = useState(0);
  const [formDataColumn, setFormDataColumn] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formId, setFormId] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  const [csvLoader, setCsvLoader] = useState(false);
  const [excelLoader, setExcelLoader] = useState(false);
  const [JSONLoader, setJSONLoader] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [showColsPanel, setShowColsPanel] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  let { studyId } = useParams();
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const [tableColumns, setTableColumns] = useState({});
  const [buttonLoader, setButtonLoader] = useState(false);

  const [datasetViewerKey, setDatasetViewerKey] = useState(0);

  const [isFullScreen, setIsFullScreen] = useState(false);
  const [sorts, setSorts] = useState([]);
  const [quick, setQuick] = useState("");
  const [showLabels, setShowLabels] = useState(false);

  const { toggle, setToggle, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4 } = UseToggle();

  const getStudyLevelForm = async (e) => {
    setLoading(true);
    let data = await studyLevelFormManagementServices.getStudyLevelForm(
      studyId,
      LoginCat,
      "active",
      StudyMode
    );
    setFormMetadataList(data?.data || []);
    setLoading(false);
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPage, setTotalPage] = useState(0);
  const startIndex = (pageNumber - 1) * itemsPerPage;

  const fetchDataset = async (type = "no", fileType = "no", datasetType = "no", page = null, length = null, allowCancel = true) => {
    return await studyDatasetsServices.getDataEntryDatasetByColumn(
      studyId,
      formId,
      type,
      fileType,
      datasetType,
      StudyMode,
      page,
      length,
      allowCancel
    );
  };

  const getDataEntryDatasetByColumn = async () => {
    setDataLoader(true);
    let data = await fetchDataset("no", "no", "datasetByColumn", pageNumber, itemsPerPage, true);
    // AbortError: a newer request replaced this one and switches the loader off itself
    if (data !== "AbortError") {
      setFormDataList(data?.data || []);
      setFormDataColumn(convertToTableData(data?.data || []));
      setFormDataCount(data?.count || 0);
      setTotalPage(data?.totalPages || 0);
      setDataLoader(false);
    }
  };

  const getAllDataEntryCSVDownloadDatasets = async (type, fileType) => {
    setCsvLoader(true);
    if (type === "query") {
      downloadCSV(formDataList, formDataColumn)
    } else {
      let data = await fetchDataset(type, fileType, "datasetByColumn", null, null, false);
      if (data === "AbortError") {
        setCsvLoader(false);
      } else {
        let formDataList = (data?.data || []);
        let formDataColumn = convertToTableData(data?.data || []);
        downloadCSV(formDataList, formDataColumn)
        setCsvLoader(false);
      }
    }
    setCsvLoader(false);
  };

  const getAllDataEntryExcelDownloadDatasets = async (type, fileType) => {
    setExcelLoader(true);
    if (type === "query") {
      downloadExcel(formDataList, formDataColumn)
    } else {
      let data = await fetchDataset(type, fileType, "datasetByColumn", null, null, false);
      if (data !== "AbortError") {
        let formDataList = (data?.data || []);
        let formDataColumn = convertToTableData(data?.data || []);
        downloadExcel(formDataList, formDataColumn)
      }
    }
    setExcelLoader(false);
  };

  const getAllDataEntryJSONDownloadDatasets = async (type, fileType) => {
    setJSONLoader(true);
    if (type === "query") {
      downloadJSON(formDataList)
    } else {
      let data = await fetchDataset(type, fileType, "datasetByColumn", null, null, false);
      if (data !== "AbortError") {
        let formDataList = (data?.data || []);
        downloadJSON(formDataList)
      }
    }
    setJSONLoader(false);
  };

  function convertToTableData(data) {
    const allColumns = new Set();
    data?.forEach(obj => {
      Object.keys(obj?.fieldRow || {}).forEach(key => {
        allColumns.add(key);
      });
    });
    return [...allColumns];
  }

  const downloadCSV = (formDataList, formDataColumn) => {
    const headers = ["Sr.", ...formDataColumn];
    const rows = formDataList.map((row, rowIndex) => {
      return [
        rowIndex + 1,
        ...formDataColumn.map((key) => row?.fieldRow?.[key] ?? ""),
      ];
    });

    const csvString = [headers, ...rows]
      .map((r) =>
        r.map((val) => `"${String(val ?? "").replace(/"/g, '""')}"`).join(",")
      )
      .join("\n");

    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", `${formDataList?.[0]?.fieldRow?.FORM || "export"}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadExcel = (formDataList, formDataColumn) => {
    const headers = ["Sr.", ...formDataColumn];
    const rows = formDataList.map((row, rowIndex) => [
      rowIndex + 1,
      ...formDataColumn.map((key) => row?.fieldRow?.[key] ?? "")
    ]);
    const data = [headers, ...rows];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const colWidths = headers.map((h, colIndex) => {
      const maxLength = Math.max(
        String(h).length,
        ...rows.map((r) => String(r[colIndex] ?? "").length)
      );
      return { wch: maxLength + 2 };
    });
    ws["!cols"] = colWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Data");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${formDataList?.[0]?.fieldRow?.FORM || "export"}.xlsx`);
  };

  const downloadJSON = (formDataList) => {
    const jsonData = formDataList.map((item) => item.fieldRow || {});

    const blob = new Blob(
      [JSON.stringify(jsonData, null, 2)],
      { type: "application/json;charset=utf-8;" }
    );

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);

    link.setAttribute(
      "download",
      `${formDataList?.[0]?.fieldRow?.FORM || "export"}.json`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      `dataListByFieldNameLabel${formId}`,
      studyId
    );
    setTableColumns(data?.data || []);
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.studyId = studyId;
        userData.type = `dataListByFieldNameLabel${formId}`;
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getTablePropertiesData();
          setDatasetViewerKey(prev => prev + 1);
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    if (formId) {
      getDataEntryDatasetByColumn();
    }
  }, [formId, pageNumber, itemsPerPage]);

  useEffect(() => {
    setPageNumber(1)
    setItemsPerPage(10)
    // Nothing of the previous form (rows, columns, column-index sorts, search) may leak into the new one
    setFormDataList([]);
    setFormDataColumn([]);
    setFormDataCount(0);
    setTableColumns({});
    setSorts([]);
    setQuick("");
    setShowFilterPanel(false);
    setShowColsPanel(false);
    getTablePropertiesData();
  }, [formId]);

  useEffect(() => {
    getStudyLevelForm();
  }, []);

  const hiddenColumns = {};
  Object.keys(tableColumns).forEach(key => {
    if (tableColumns[key] === true) {
      hiddenColumns[key] = true;
    }
  });

  const handleSort = (colIndex, multi, direction = null) => {
    const idx = sorts.findIndex(s => s.col === colIndex);
    if (!multi) {
      if (direction) {
        setSorts([{ col: colIndex, dir: direction }]);
      } else if (idx >= 0) {
        const newDir = sorts[idx].dir === "asc" ? "desc" : "asc";
        setSorts([{ col: colIndex, dir: newDir }]);
      } else {
        setSorts([{ col: colIndex, dir: "asc" }]);
      }
    } else {
      if (idx >= 0) {
        if (direction) {
          const newSorts = [...sorts];
          newSorts[idx] = { col: colIndex, dir: direction };
          setSorts(newSorts);
        } else {
          const newSorts = [...sorts];
          const newDir = newSorts[idx].dir === "asc" ? "desc" : "asc";
          newSorts[idx] = { col: colIndex, dir: newDir };
          setSorts(newSorts);
        }
      } else {
        setSorts([...sorts, { col: colIndex, dir: direction || "asc" }]);
      }
    }
  };

  const firstSort = sorts[0];

  const clearSorts = () => {
    setSorts([]);
  };

  const handleReset = () => {
    clearSorts();
    setQuick("");
    setShowLabels(false);
    setShowFilterPanel(false);
    setShowColsPanel(false);
    setResetKey(prev => prev + 1);
  };

  return (
    <>
      <SplitPane split="vertical" minSize={"20%"} className="position-relative" style={{ height: "calc(100vh - 145px)" }}>
        {loading ? (
          <PageLoader />
        ) : formMetadataList?.length === 0 ? (
          <div className="hstack justify-content-center h-100">
            <NoDataFoundTable MSG={"Data list not found!"} />
          </div>
        ) : (
          <ListGroup className="p-2">
            {formMetadataList?.map((form, index) => (
              <ListGroup.Item action
                title={form?.formLabel}
                onClick={() => {
                  setFormId(form?.formId);
                }}
                key={index}
                style={{ padding: "7px 0px 7px 10px" }}
                className={`hstack ${formId === form?.formId && "selectedMenu"}`}
              >
                <span>{form?.formName}</span>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
        <>
          <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
            {formId &&
              <div className="hstack gap-1">
                <i
                  onClick={() => { setShowFilterPanel(!showFilterPanel); if (!showFilterPanel) setShowColsPanel(false); }}
                  title="Open Filter" className={`fa-solid ${!showFilterPanel ? "fa-filter" : "fa-filter-circle-xmark text-danger"}`}></i>
                <div className="vr"></div>
                <i onClick={() => setShowLabels(!showLabels)} title="Labels" className="fa-solid fa-tags"></i>
                <div className="vr"></div>
                <i onClick={handleReset} title="Reset" className="fa-solid fa-arrow-rotate-left" style={{ cursor: "pointer" }}></i>
                <div className="vr"></div>
                <i
                  onClick={() => setIsFullScreen(!isFullScreen)}
                  title={isFullScreen ? "Exit Full Screen" : "Full Screen"}
                  className={`fa-solid fa-maximize ${isFullScreen ? "text-danger" : ""}`}
                  style={{ cursor: "pointer" }}
                ></i>
                <div className="vr"></div>
                <Form.Control
                  type="text"
                  size="sm"
                  style={{ width: "150px" }}
                  placeholder="🔍 Search all columns"
                  value={quick}
                  onChange={(e) => setQuick(e.target.value)}
                />
                <div className="vr"></div>
                <InputGroup size="sm" style={{ width: "220px" }}>
                  <Form.Select
                    style={{ maxWidth: "150px" }}
                    className="rounded-end-danger rounded-end-0"
                    value={sorts[0]?.col ?? ""}
                    onChange={(e) => {
                      const colIndex = Number(e.target.value);
                      if (e.target.value === "") {
                        clearSorts();
                      } else {
                        handleSort(colIndex, false, "asc");
                      }
                    }}
                  >
                    <option value="">Sort by...</option>
                    {formDataColumn.map((col, index) => (
                      <option key={col} value={index}>{col}</option>
                    ))}
                  </Form.Select>
                  {sorts?.length > 0 &&
                    <button
                      className="removeProfile"
                      onClick={clearSorts}
                    >
                      Clear
                    </button>
                  }
                </InputGroup>
              </div>
            }
            {formDataColumn?.length > 0 && (
              <div className="gap-1 hstack">
                <button
                  className={`updateProfile`}
                  onClick={() => setToggle()}
                >
                  Properties
                </button>
                <button
                  onClick={setToggle3}
                  className={`updateProfile`}
                  disabled={csvLoader}
                >
                  CSV File
                </button>
                <button
                  disabled={excelLoader}
                  onClick={setToggle4}
                  className={`updateProfile`}
                >
                  Excel File
                </button>
                <button
                  onClick={setToggle2}
                  className={`updateProfile`}
                >
                  JSON File
                </button>
              </div>
            )}
          </div>
          {/* While another page loads, the viewer stays mounted (keeps its filters) and shows its own loader */}
          {dataLoader && formDataList.length === 0 ? (
            <div className="hstack justify-content-center"
              style={{ height: "calc(100vh - 182px)" }}>
              <img src={Loader} alt="Page Loader" />
            </div>
          ) : !formId ? (
            <div className="hstack justify-content-center fw-bold text-muted"
              style={{ height: "calc(100vh - 182px)" }}>
              Not any field!
            </div>
          ) : formDataCount === 0 && !dataLoader ? (
            <NoDataFoundTable MSG={"Data Not Found!"} />
          ) : (
            <>
              <div className="overflow-auto" style={{ height: "calc(100vh - 182px)" }}>
                <DatasetViewer
                  key={`${formId}-${datasetViewerKey}`}
                  loading={dataLoader}
                  data={formDataList}
                  columns={formDataColumn}
                  hiddenColumns={hiddenColumns}
                  startIndex={startIndex}
                  showSrColumn={true}
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                  isFullScreen={isFullScreen}
                  sorts={sorts}
                  quick={quick}
                  showLabels={showLabels}
                  handleSort={handleSort}
                  clearSorts={clearSorts}
                  setQuick={setQuick}
                  setShowLabels={setShowLabels}
                  setIsFullScreen={setIsFullScreen}
                  toggle={toggle}
                  setToggle={setToggle}
                  exportCSVFile={getAllDataEntryCSVDownloadDatasets}
                  exportExcelFile={getAllDataEntryExcelDownloadDatasets}
                  exportJSONFile={getAllDataEntryJSONDownloadDatasets}
                  setShowFilterPanel={setShowFilterPanel}
                  showFilterPanel={showFilterPanel}
                  setShowColsPanel={setShowColsPanel}
                  showColsPanel={showColsPanel}
                  resetKey={resetKey}
                  csvLoader={csvLoader}
                  excelLoader={excelLoader}
                  JSONLoader={JSONLoader}
                  studyPermission={studyPermission}
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={formDataCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />

              </div>
            </>
          )}
        </>
      </SplitPane>

      <TableProperties
        Show={!toggle}
        Hide={setToggle}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formDataColumn={formDataColumn}
        tableColumns={tableColumns}
        buttonLoader={buttonLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <ExportJSONData
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Export Json File"}
        getAllDataEntryJSONDownloadDatasets={getAllDataEntryJSONDownloadDatasets}
        JSONLoader={JSONLoader}
        studyPermission={studyPermission}
      />
      <ExportCSVData
        Show={!toggle3}
        Hide={setToggle3}
        Title={"Export CSV File"}
        getAllDataEntryCSVDownloadDatasets={getAllDataEntryCSVDownloadDatasets}
        csvLoader={csvLoader}
        studyPermission={studyPermission}
      />
      <ExportEXCELData
        Show={!toggle4}
        Hide={setToggle4}
        Title={"Export Excel File"}
        getAllDataEntryExcelDownloadDatasets={getAllDataEntryExcelDownloadDatasets}
        excelLoader={excelLoader}
        studyPermission={studyPermission}
      />
    </>
  );
};

export default DatasetListByColumn;
